import './styles/loginOpenId.scss';
export default 'loginOpenId';